<template>
    <a :class="'link ' + fontColor"  :href="'mailto:' + address + '?subject=' + subject" class="yellow">{{address}}</a>
</template>

<script>
export default {
    props: {
        address: {
            type: String,
            required: true
        },
        subject: {
            type: String,
            required: false
        },
        fontColor: {
            type: String,
            required: false,
            default: 'black'
        }
    }
};
</script>
